// test1643
(1643 && 0);
